import React from "react";

import { PageWrapper } from "~/components/layout/PageWrapper";

const SuspenseFallback: React.FC = () => {
  return <PageWrapper>{/* <CircularProgress /> */}</PageWrapper>;
};

export default SuspenseFallback;
